import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import useAuth from "../../hooks/useAuth";
import { authApi } from "../../lib/auth";
import { errorMessage } from "../../lib/api";
import { Input } from "../ui/input";

export default function PasswordCard({ forced = false, onChanged }) {
  const { setSession } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      const session = await authApi.changePassword({ current_password: form.current_password, new_password: form.new_password });
      setSession(session);
      setForm({ current_password: "", new_password: "", confirm: "" });
      toast.success("Password updated");
      onChanged?.();
    } catch (err) {
      toast.error("Could not change password", { description: errorMessage(err) });
    } finally {
      setBusy(false);
    }
    return undefined;
  };

  return (
    <section className="ws-card glass" data-testid="password-card">
      <h2>
        <KeyRound size={16} /> {forced ? "Set a new password" : "Password"}
      </h2>
      <p className="muted">{forced ? "You signed in with a temporary password. Choose your own before continuing." : "At least 10 characters with upper & lower case letters and a number."}</p>
      <form onSubmit={submit} className="ws-form narrow">
        <label className="auth-field">
          <span>{forced ? "Temporary password" : "Current password"}</span>
          <Input type="password" value={form.current_password} onChange={set("current_password")} required autoComplete="current-password" data-testid="pw-current" />
        </label>
        <label className="auth-field">
          <span>New password</span>
          <Input type="password" value={form.new_password} onChange={set("new_password")} required minLength={10} autoComplete="new-password" data-testid="pw-new" />
        </label>
        <label className="auth-field">
          <span>Confirm new password</span>
          <Input type="password" value={form.confirm} onChange={set("confirm")} required minLength={10} autoComplete="new-password" data-testid="pw-confirm" />
        </label>
        <button type="submit" className="tb-btn primary" disabled={busy} data-testid="pw-submit">
          {busy && <Loader2 size={14} className="spin" />} {forced ? "Save and continue" : "Change password"}
        </button>
      </form>
    </section>
  );
}
